import type { GameState } from "../game/GameState";
import type { PickupKind } from "../generation/types";

export class PlayerInventory {
  public constructor(private readonly state: GameState) {}

  public collect(kind: PickupKind): boolean {
    switch (kind) {
      case "health":
        return this.state.addHealth(25);
      case "armor":
        return this.state.addArmor(50);
      case "bullets":
        return this.state.addAmmo("pistol", 18);
      case "shells":
        return this.state.addAmmo("shotgun", 8);
      case "shotgun":
        return this.state.grantShotgun();
      case "rifle":
        return this.state.grantRifle();
      case "rifleAmmo":
        return this.state.addAmmo("rifle", 30);
    }
  }
}
